import {
  Component,
  OnInit,
  OnDestroy,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
  RouterLinkActive,
} from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AgentsService } from '@app/services/agents.service';
import { UserService } from '@app/services/user.service';

interface Tab {
  id: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'blu-agent',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
  ],
  templateUrl: './agent.component.html',
  styleUrl: './agent.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AgentComponent implements OnInit, OnDestroy {
  agent$ = this.agentsService.agent$;
  loading = false;

  tabs: Tab[] = [
    { id: 'instructions', label: 'Instruções', icon: 'edit_note' },
    { id: 'faq', label: 'Perguntas', icon: 'help' },
    { id: 'simulation', label: 'Simulação', icon: 'forum' },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private agentsService: AgentsService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.agentsService.resetMessages();
  }

  async init() {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) return;
    await this.agentsService.getAgent(id);
  }

  async deleteAgent() {
    const agent = this.agentsService.getCurrentAgent();
    if (!agent.uid) return;
    await this.agentsService.deleteAgent(agent.uid);
    this.router.navigate(['/admin/chat/agents']);
  }

  async save() {
    const agent = this.agentsService.getCurrentAgent();
    if (!agent.uid) return;

    this.loading = true;
    try {
      await this.agentsService.updateAgent(agent.uid, {
        ...agent,
        organization: this.userService.organization()?.uid as string,
      });
    } finally {
      this.loading = false;
    }
  }
}
